import {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';
import { apiAccessRequestAPI } from '../../../api';

import { GridColDef } from '@mui/x-data-grid';
import { convertToDateTime, StyledDataGrid, dataGridCellClassName, dataGridHeaderClassName } from '../../../utils'

import {APIAccessRequestReviewModal} from './APIAccessRequestReviewModal'

import toastr from 'toastr'

interface Props {
}

const APIAccessRequests : React.FC<Props> = ({}) => {

  const [loaded, setLoaded] = useState<boolean>(false)
  const [requests, setRequests] = useState<any[]>([])

  const [currentRequest, setCurrentRequest] = useState<any | null>(null)

  const [showReviewModal, setShowReviewModal] = useState<boolean>(false)

  useEffect(() => {
    loadProjects()
  }, [])

  useEffect(() => {
    if( currentRequest ){
      setShowReviewModal(true)
    }else{
      setShowReviewModal(false)
    }
  }, [currentRequest])

  async function loadProjects(){
    let {data: data} = await apiAccessRequestAPI.getAll()
    setRequests(data['data'])
    setLoaded(true)
  }

  async function handleUpdate(){
    setCurrentRequest(null)
    await loadProjects()
    toastr.info("Updated")
  }

  const columnsForMessages: GridColDef[] = [
    { field: "created_by_email", headerName: 'Created By (Admin)', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "created_dt", headerName: 'Requested On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 180,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    },
    { field: "full_name", headerName: 'Full Name', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "email", headerName: 'Email', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "organization", headerName: 'Organization', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "use_case", headerName: 'Use Case', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200, flex:1,
      renderCell: (params) => {
        return <div className="overflow-y-auto" style={{maxHeight: '142px'}}>{params.value}</div>
      }
    },
    { field: 'status', headerName: 'Status', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150,
      renderCell: (params) => {
        return params.row.status == 'pending' 
        ?
          <button className="btn btn-primary btn-sm fs-8 px-2 py-1" onClick={()=>setCurrentRequest(params.row)}>Review</button>
        :
          <>
          <span className={`badge badge-light-${params.value == 'approved' ? 'primary' : 'danger'}`}>
            {params.value}
          </span>
          {params.row.status == 'approved' && <Link className="btn btn-primary btn-sm fs-8 px-2 py-1" to={`/admin/api-accesses/${params.row.project_id}`}>Go to the access</Link>}
          </>
      }
    },
    { field: 'updated_dt', headerName: 'Updated On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 180,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    },
    { field: 'updated_by_email', headerName: 'Updated By', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "review_comment", headerName: 'Review Comment by Admin', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200, flex:1,
      renderCell: (params) => {
        return <div className="overflow-y-auto" style={{maxHeight: '142px'}}>{params.value}</div>
      }
    }
  ]

  return (
    <div className="row">
      <div className="col-12">
          {loaded && (
            <StyledDataGrid
              getRowId={(row) => row.id}
              rows={requests}
              columns={columnsForMessages}
              disableColumnMenu={false}
              getRowHeight={() => 'auto'}
              disableRowSelectionOnClick
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 50 },
                }
              }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
              pageSizeOptions={[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100]}
            />
          )}
          { showReviewModal && currentRequest && <APIAccessRequestReviewModal request={currentRequest} show={showReviewModal} handleClose={()=>setCurrentRequest(null)} handleUpdated={handleUpdate}/>}
      </div>
    </div>
  )
}

export default APIAccessRequests